import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.75 15.75c-.413 0-.766-.147-1.06-.44a1.445 1.445 0 0 1-.44-1.06V3.75c0-.413.147-.766.44-1.06.294-.293.647-.44 1.06-.44H9v1.5H3.75v10.5h10.5V9h1.5v5.25c0 .412-.147.766-.44 1.06a1.45 1.45 0 0 1-1.06.44H3.75Zm3.525-3.975-1.05-1.05L13.2 3.75h-2.7v-1.5h5.25V7.5h-1.5V4.8l-6.975 6.975Z"
    />
  </svg>
);
export const ExternalLinkIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
